import React, { useEffect } from "react";

function OfficeForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  
  // Debug logging
  useEffect(() => {
    console.log('🏢 OfficeForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const finalValue = type === "checkbox" ? checked : value;
    
    console.log(`🔧 Field changed: ${name} = ${finalValue} (type: ${typeof finalValue})`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: finalValue,
    });
  };

  return (
    <div className="officeForm">
      {/* Ünvan */}
      <div>
        <h3>
          Ünvan <span>*</span>
          <span className="tooltip-icon" title="Rayon, küçə, bina">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="address" 
          placeholder="Nəsimi rayonu, Zərifə Əliyeva küçəsi 10" 
          onChange={handleChange} 
          required 
        />
      </div>

      {/* Obyekt növü – genişləndirilmiş seçimlər */}
      <div>
        <h3>
          Obyekt növü <span>*</span>
          <span className="tooltip-icon" title="Kommersiya obyektinin tipi">ℹ️</span>
        </h3>
        <select name="propertyType" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Ofis">Ofis (Office)</option>
          <option value="Mağaza">Mağaza (Shop)</option>
          <option value="Anbar">Anbar (Warehouse)</option>
          <option value="Ticarət Mərkəzi">Ticarət Mərkəzi (Mall)</option>
          <option value="Aptek">Aptek (Pharmacy)</option>
          <option value="Klinika">Klinika (Clinic)</option>
          <option value="Salon">Salon (Beauty/Barber)</option>
          <option value="Notarius">Notarius</option>
          <option value="Atelye">Atelye (Tailor)</option>
          <option value="Studiya">Studiya (Studio)</option>
          <option value="Tədris Mərkəzi">Tədris Mərkəzi</option>
          <option value="Restoran / Kafe">Restoran / Kafe</option>
          <option value="Zavod">Zavod (Factory)</option>
          <option value="Digər">Digər</option>
        </select>
      </div>

      {/* Ümumi sahə */}
      <div>
        <h3>
          Ümumi sahə (m²) <span>*</span>
          <span className="tooltip-icon" title="Kvadrat metrlə">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="area" 
          min="5" 
          placeholder="120"
          onChange={handleChange} 
          required 
        />
      </div>

      {/* Otaq sayı */}
      <div>
        <h3>
          Otaq sayı <span>*</span>
          <span className="tooltip-icon" title="Bölmə sayı">ℹ️</span>
        </h3>
        <select name="roomCount" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1">1 otaq (Open space)</option>
          <option value="2">2 otaq</option>
          <option value="3">3 otaq</option>
          <option value="4">4 otaq</option>
          <option value="5">5+ otaq</option>
        </select>
      </div>

      {/* Mərtəbə */}
      <div>
        <h3>
          Mərtəbə
          <span className="tooltip-icon" title="Obyektin mərtəbəsi">ℹ️</span>
        </h3>
        <select name="floor" onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Zirzəmi">Zirzəmi (Basement)</option>
          <option value="1">1-ci mərtəbə</option>
          <option value="2">2-ci mərtəbə</option>
          <option value="3">3-cü mərtəbə</option>
          <option value="4">4-cü mərtəbə</option>
          <option value="5">5+ mərtəbə</option>
        </select>
      </div>

      {/* İstilik sistemi */}
      <div>
        <h3>
          İstilik sistemi <span>*</span>
          <span className="tooltip-icon" title="Qızdırma sistemi">ℹ️</span>
        </h3>
        <select name="heatingSystem" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Mərkəzi istilik">Mərkəzi istilik (Central)</option>
          <option value="Kombi">Kombi (Boiler)</option>
          <option value="Elektrik">Elektrik radiator</option>
          <option value="Kondisioner">Kondisioner</option>
          <option value="Yoxdur">Yoxdur</option>
        </select>
      </div>

      {/* Təmir vəziyyəti */}
      <div>
        <h3>
          Təmir vəziyyəti <span>*</span>
          <span className="tooltip-icon" title="Daxili təmir">ℹ️</span>
        </h3>
        <select name="renovationStatus" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Təmirli">Təmirli (Yeni təmir)</option>
          <option value="Orta">Orta vəziyyət</option>
          <option value="Təmirsiz">Təmirsiz (Köhnə)</option>
        </select>
      </div>

      {/* Sənəd tipi */}
      <div>
        <h3>
          Sənəd tipi <span>*</span>
          <span className="tooltip-icon" title="Mülkiyyət sənədi">ℹ️</span>
        </h3>
        <select name="documentType" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Kupça">Kupça (Deed)</option>
          <option value="Müqavilə">Müqavilə (Contract)</option>
          <option value="İcarə müqaviləsi">İcarə müqaviləsi (Lease)</option>
          <option value="Yoxdur">Sənəd yoxdur</option>
        </select>
      </div>

      {/* Əşyalı */}
      <div>
        <h3>
          Əşyalı? <span>*</span>
          <span className="tooltip-icon" title="Mebel və avadanlıq">ℹ️</span>
        </h3>
        <select name="isFurnished" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (Əşyalı) ✅</option>
          <option value="false">Xeyr (Boş) ❌</option>
        </select>
      </div>

      {/* Park yeri */}
      <div>
        <h3>
          Park yeri <span>*</span>
          <span className="tooltip-icon" title="Avtomobil park yeri">ℹ️</span>
        </h3>
        <select name="hasParking" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Siqnalizasiya */}
      <div>
        <h3>
          Siqnalizasiya sistemi <span>*</span>
          <span className="tooltip-icon" title="Alarm sistemi">ℹ️</span>
        </h3>
        <select name="hasAlarmSystem" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Kamera müşahidəsi */}
      <div>
        <h3>
          Kamera müşahidəsi <span>*</span>
          <span className="tooltip-icon" title="CCTV sistemi">ℹ️</span>
        </h3>
        <select name="hasCameraSystem" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* İnternet */}
      <div>
        <h3>
          İnternet <span>*</span>
          <span className="tooltip-icon" title="İnternet qoşulması">ℹ️</span>
        </h3>
        <select name="hasInternet" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Kondisioner */}
      <div>
        <h3>
          Kondisioner <span>*</span>
          <span className="tooltip-icon" title="A/C sistemi">ℹ️</span>
        </h3>
        <select name="hasAirConditioner" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* WC */}
      <div>
        <h3>
          Sanitar qovşağı <span>*</span>
          <span className="tooltip-icon" title="Tualet / Vanna">ℹ️</span>
        </h3>
        <select name="hasWC" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Mətbəx */}
      <div>
        <h3>
          Mətbəx
          <span className="tooltip-icon" title="Ayrı mətbəx sahəsi">ℹ️</span>
        </h3>
        <select name="hasKitchen" onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Kommunallar */}
      <div>
        <h3>
          Qaz <span>*</span>
          <span className="tooltip-icon" title="Təbii qaz">ℹ️</span>
        </h3>
        <select name="hasGas" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Su <span>*</span>
          <span className="tooltip-icon" title="İçməli su">ℹ️</span>
        </h3>
        <select name="hasWater" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Elektrik <span>*</span>
          <span className="tooltip-icon" title="Elektrik şəbəkəsi">ℹ️</span>
        </h3>
        <select name="hasElectricity" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Lift */}
      <div>
        <h3>
          Lift
          <span className="tooltip-icon" title="Lift varmı?">ℹ️</span>
        </h3>
        <select name="hasElevator" onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Generator */}
      <div>
        <h3>
          Generator
          <span className="tooltip-icon" title="Ehtiyat elektrik">ℹ️</span>
        </h3>
        <select name="hasGenerator" onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>
    </div>
  );
}

export default OfficeForm;